import { FaqSchema } from "@/components/FaqSchema";
import { ContentPageNav } from "@/components/ContentPageNav";
import { Footer } from "@/components/Footer";

const html = `<nav aria-label="Kruimelpad" class="px-3 pt-4 pb-2"><div class="container mx-auto max-w-6xl"><ol class="flex flex-wrap items-center gap-2 text-sm"><li class="flex items-center gap-2"><a href="/" class="text-muted-foreground hover:text-foreground transition-colors">Home</a></li><li class="text-foreground font-medium" aria-current="page">Spelers automatisch indelen</li></ol></div></nav>

  <header class="py-10 md:py-20 px-3">
    <div class="container mx-auto max-w-3xl">
      <h1 class="text-3xl md:text-5xl font-bold text-foreground mb-6">Tennisspelers automatisch indelen — hoe werkt dat?</h1>
      <p class="text-lg md:text-xl text-muted-foreground leading-relaxed">Handmatig spelers indelen kost tijd, leidt tot fouten en geeft regelmatig discussie ("ik heb te weinig gespeeld"). Een goed <strong>indelingsalgoritme</strong> regelt het eerlijk, snel en transparant. Dit is hoe het algoritme van De Hussel App werkt.</p>
    </div>
  </header>

  <article class="px-3 pb-6">
    <div class="container mx-auto max-w-3xl space-y-8">
      
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Waarom automatisch indelen?</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><ul class="list-disc pl-6 space-y-1"><li>Eerlijke speeltijd voor iedereen.</li><li>Geen discussies meer over wie met wie speelt.</li><li>Tijdwinst voor de husselaar.</li><li>Real-time aanpassen bij laatkomers/afmeldingen.</li></ul></div>
        </section>
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Op basis waarvan deelt het algoritme in?</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><ol class="list-decimal pl-6 space-y-1"><li><strong>Speelniveau</strong> — gelijkwaardige partijen.</li><li><strong>Gespeelde rondes</strong> — wie het minst speelde, krijgt voorrang.</li><li><strong>Cooling-down</strong> — niemand speelt 5 rondes achter elkaar zonder rust.</li><li><strong>Eerdere tegenstanders/partners</strong> — variatie is het doel.</li><li><strong>Aanwezigheid</strong> — alleen ingecheckte spelers worden ingedeeld.</li></ol></div>
        </section>
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Het belangrijkste principe</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><p>Bij De Hussel App geldt één regel: <strong>maximaliseer speeltijd</strong>. Het algoritme breekt liever een "perfecte" niveau-indeling dan dat het iemand een ronde laat overslaan. Resultaat: jouw leden spelen meer en wachten minder.</p></div>
        </section>
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Wat als er een oneven aantal komt?</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><p>Banen worden <strong>strikt</strong> met 2 of 4 spelers ingedeeld — nooit 3. Bij een oneven aantal rouleren spelers eerlijk, zodat iedereen evenveel speeltijd krijgt.</p></div>
        </section>
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Is dit ook handmatig te overrulen?</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><p>Ja. Een beheerder kan altijd ingrijpen — bijvoorbeeld als een speler net is geblesseerd of een partner-voorkeur heeft. Het algoritme is een hulpmiddel, geen dictator.</p></div>
        </section>
    </div>
  </article>

  <section class="py-10 md:py-16 px-3">
    <div class="container mx-auto max-w-3xl">
      <div class="p-5 md:p-10 text-center rounded-lg border border-accent/30 bg-accent/10">
        <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Klaar om dit voor je club te automatiseren?</h2>
        <p class="text-lg text-muted-foreground mb-6">De Hussel App regelt aanmelden, indelen en push-meldingen — voor husselen, tossen en racket trekken.</p>
        <a href="/club-register" class="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-accent text-accent-foreground font-medium hover:bg-accent/90 transition-colors">Registreer je club </a>
      </div>
    </div>
  </section>

  
  <section class="py-10 md:py-16 px-3">
    <div class="container mx-auto max-w-4xl">
      <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-6 md:mb-8 text-center">Veelgestelde vragen</h2>
      <div class="space-y-3">
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Hoe weet het algoritme welk niveau een speler heeft?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">Bij registratie of via een rating-veld in het ledenprofiel. Voor verenigingen die KNLTB-rating bijhouden, kun je dat als basis gebruiken.</div>
    </details>
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Wat als een speler te laat komt?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">Late aanmelders worden in de volgende ronde meegenomen, zonder de lopende ronde te verstoren.</div>
    </details>
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Speelt iedereen evenveel?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">Het algoritme streeft naar maximale, eerlijke speeltijd. Bij oneven aantallen rouleren spelers; over een hele avond komt iedereen op vergelijkbare speeltijd uit.</div>
    </details>
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Kan ik partner-voorkeuren instellen?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">Het algoritme houdt rekening met variatie. Vaste duos zijn standaard uitgeschakeld; clubs die dat willen kunnen het in de instellingen aanzetten.</div>
    </details>
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Hoe transparant is de indeling?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">Per speler is in de historie te zien op basis waarvan een indeling tot stand is gekomen (JSONB-beslislogs per speler).</div>
    </details></div>
    </div>
  </section>`;

const AutomatischIndelenTennisspelers = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <ContentPageNav showPricing />
      <div
        className="flex-1 marketing-content"
        dangerouslySetInnerHTML={{ __html: html }}
      />
      <FaqSchema html={html} />
      <Footer />
    </div>
  );
};

export default AutomatischIndelenTennisspelers;
